export const newsArticles = [
  {
    id: 'tanks-gamemode',
    date: 'December 13, 2025',
    tag: 'announcement',
    title: 'Sneak peak Tanks! 🎖️',
    excerpt: 'We are happy to reveal an exciting new addition to Voxale: Tanks, our brand-new gamemode where players can battle it out in custom-built arenas using powerful tanks!',
    thumbnail: null,
    heroImage: 'https://i.imgur.com/O54CrnH.jpeg',
    content: `We are happy to reveal an exciting new addition to Voxale: **Tanks**, our brand-new gamemode where players can battle it out in custom-built arenas using powerful tanks!
    
### Gamemode Overview
In Tanks, players will pilot heavily armed tanks in team-based battles across a variety of dynamic maps. Each tank is equipped with unique weapons and abilities, allowing for strategic gameplay and intense combat.

### Maps
Our initial release will feature three distinct maps:
- **Desert Storm**: A wide-open desert landscape with plenty of cover and long sightlines.
- **Urban Warfare**: A dense cityscape filled with buildings and narrow alleyways for close-quarters combat.
- **Forest Frenzy**: A wooded area with natural obstacles and hidden paths for ambush tactics.

### Tank Types
Players can choose from several tank types, each with its own strengths and weaknesses:
- **Light Tank**: Fast and agile, perfect for hit-and-run tactics.
- **Medium Tank**: Balanced speed and firepower, ideal for versatile gameplay.
- **Heavy Tank**: Slow but heavily armored, capable of soaking up damage and dealing massive blows.

### Game Modes
Tanks will feature multiple game modes, including:
- **Team Deathmatch**: Classic team-based combat where the goal is to eliminate the opposing team.
- **Capture the Flag**: Teams must capture the enemy's flag while defending their own.
- **King of the Hill**: Control designated areas on the map to earn points for your team.`
  },
  {
    id: 'winter-event',
    date: 'December 8, 2025',
    tag: 'event',
    title: 'Winter Event Now Live! ❄️',
    excerpt: 'The snow has fallen on Voxale! Join our winter festivities with exclusive rewards, frozen dungeons, and the legendary Ice Dragon boss...',
    thumbnail: null,
    heroImage: null,
    content: `The snow has fallen on Voxale! We're excited to announce that our annual **Winter Event** is now live and will run until *January 5th, 2026*.

![Winter Spawn](https://images.unsplash.com/photo-1477601263568-180e2c6d046e?w=800&q=80)

## What's New

### 🏔️ Frozen Dungeons
Explore three brand new ice-themed dungeons with unique mobs, puzzles, and treasure. Each dungeon offers different difficulty levels with scaling rewards.

> "The Frost Caverns are unlike anything we've built before!" - Build Team

### 🐉 Ice Dragon Boss
Challenge the legendary Ice Dragon in our new world boss event! The dragon spawns every 4 hours and drops exclusive winter gear and the rare **Frostfire Wings** cosmetic.

![Ice Dragon](https://images.unsplash.com/photo-1577493340887-b7bfff550145?w=800&q=80)

### 🎁 Advent Calendar
Log in daily to claim free rewards! The calendar includes:
- Vote keys
- Coins
- Exclusive cosmetics
- Mystery grand prize on Christmas Day

### ❄️ Snow Globe Spawn
Our spawn has been transformed into a magical winter wonderland complete with ice skating, snowball fights, and hidden presents to find.

### 🛷 Limited Items
Visit the **Winter Shop** to spend your Snowflakes (earned from event activities) on exclusive winter cosmetics, pets, and gear that won't return until next year!

---

Happy holidays from the entire Voxale team! We hope you enjoy the event. ⛄`
  },
  {
    id: 'new-spawn',
    date: 'December 1, 2025',
    tag: 'update',
    title: 'New Spawn Released',
    excerpt: "We've completely redesigned our spawn area with new shops, parkour courses, and a grand central hub...",
    thumbnail: null,
    heroImage: null,
    content: `We've completely redesigned our spawn area from the ground up! After months of work from our build team, we're proud to unveil the new **Voxale Central Hub**.

![New Spawn Overview](https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=800&q=80)

## Features

### 🏪 Merchant District
All NPC shops are now organized in a beautiful marketplace. Find the Blacksmith, Enchanter, Banker, and more all in one convenient location.

| Shop | Location | Items |
|------|----------|-------|
| Blacksmith | East Wing | Weapons & Armor |
| Enchanter | Tower | Enchantments |
| Banker | Central | Currency Exchange |
| Farmer | West Wing | Food & Seeds |

### 🏃 Parkour Courses
Three new parkour courses have been added:

1. **Easy Course** - Perfect for beginners, 50 coin reward
2. **Medium Course** - Some tricky jumps, 150 coin reward  
3. **Hard Course** - Only for experts, 500 coin reward + title

### 🗺️ Navigation Improvements
Clear signage and a central directory make finding your way around easier than ever. New players will love the guided tour NPCs.

### 🎨 Visual Upgrade
Custom textures, particle effects, and ambient sounds bring the spawn to life. 

> Make sure you have your resource pack enabled!

---

We'd love to hear your feedback on the new spawn. Let us know what you think in our Discord!`
  },
  {
    id: 'pvp-season-4',
    date: 'November 25, 2025',
    tag: 'announcement',
    title: 'PvP Season 4 Champions',
    excerpt: 'Congratulations to DragonSlayer99 for winning Season 4! New season starts December 15th...',
    thumbnail: null,
    heroImage: null,
    content: `Season 4 of our competitive PvP league has come to a close, and what a season it was! Congratulations to all participants.

![PvP Arena](https://images.unsplash.com/photo-1542751371-adc38448a05e?w=800&q=80)

## 🏆 Final Standings

| Rank | Player | Points |
|------|--------|--------|
| 🥇 1st | DragonSlayer99 | 2,847 |
| 🥈 2nd | xXShadowKnightXx | 2,691 |
| 🥉 3rd | CrystalBlade | 2,544 |

## Rewards Distributed

- **Champion Title & Crown Cosmetic** - 1st place
- **50,000 Coins + Legendary Key Bundle** - Top 3
- **Exclusive Season 4 Cape** - Top 10
- **Participation Trophy Cosmetic** - All ranked players

## Season 5 Preview

The next season begins on **December 15th** with exciting changes:

- ⚔️ New arena map
- ⚖️ Rebalanced kits
- 📊 Completely overhauled ranking system

> "Season 5 will be our most competitive season yet!" - Staff Team

---

Thank you to everyone who competed this season. See you in the arena! ⚔️`
  },
  {
    id: 'server-upgrade',
    date: 'November 15, 2025',
    tag: 'update',
    title: 'Server Hardware Upgrade Complete',
    excerpt: "We've just completed a major server infrastructure upgrade to provide you with an even better playing experience!",
    thumbnail: null,
    heroImage: null,
    content: `We've just completed a major server infrastructure upgrade to provide you with an even better playing experience!

![Server Room](https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80)

## What's Improved

### ⚡ Better Performance
Our new dedicated servers feature the latest **AMD EPYC processors** and **NVMe storage**, reducing lag and improving TPS stability.

\`\`\`
Before: 18-19 TPS average
After:  20 TPS stable 🎉
\`\`\`

### 🌍 Lower Latency
We've added new server nodes in:
- Europe (Frankfurt)
- Asia (Singapore)
- Australia (Sydney)

### 💾 Improved Backups
| Feature | Before | After |
|---------|--------|-------|
| Backup Frequency | 6 hours | 1 hour |
| Retention | 7 days | 30 days |
| Recovery Time | ~30 min | ~5 min |

### 🛡️ Enhanced DDoS Protection
Upgraded security measures to keep the server running smoothly even during attacks.

---

These upgrades were made possible by our amazing community and store supporters. **Thank you!**`
  },
  {
    id: 'halloween-recap',
    date: 'November 2, 2025',
    tag: 'event',
    title: 'Halloween Event Recap 🎃',
    excerpt: "Our Halloween event has wrapped up, and it was our biggest one yet! Here's a look back at the spooky festivities.",
    thumbnail: null,
    heroImage: null,
    content: `Our Halloween event has wrapped up, and it was our biggest one yet! Here's a look back at the spooky festivities.

![Halloween Event](https://images.unsplash.com/photo-1509557965875-b88c97052f0e?w=800&q=80)

## 📊 Event Statistics

| Metric | Count |
|--------|-------|
| Players Participated | 4,521 |
| Pumpkins Collected | 12,847 |
| Haunted Dungeon Completions | 892 |
| Headless Horseman Mounts | 156 |

## 🏆 Contest Winners

### Best Haunted House Build
**SpookyBuilder_MC** created an incredible haunted mansion complete with redstone-powered jump scares!

### Best Costume
**GhostFace2025** won with their terrifyingly accurate ghost costume using custom armor.

### Pumpkin Collection Champion
**PumpkinKing99** collected over *500 pumpkins* in a single day!

> All event cosmetics have been distributed. If you participated but didn't receive your rewards, please open a ticket on Discord.

---

Thank you for making this Halloween unforgettable! See you next year! 👻`
  }
];

export const getArticleById = (id) => {
  return newsArticles.find(article => article.id === id);
};
